




















































































































































import { Component, Vue } from "vue-property-decorator";
import store from "../../core/store";
import { Settings, TenantSettings } from "../../core/services/configService";
import { Format } from "../../core/helpers/formatHelper";
import { CrudService } from "../../core/services/crudService";
import { Global } from "../../core/helpers/global";

@Component({})
export default class Footer extends Vue {
  settings: TenantSettings = {};
  currentYear: number = new Date().getFullYear();

  hideRequestInfoFrom: boolean = false;
  requestEmail: string = "";
  requestInfoMessage: string = "";

  mounted() {
    this.settings = store.state.settings;
    this.requestInfoMessage = this.$t(
      "We will contact you as soon as possible",
    ).toString();
  }

  get tenantTitle() {
    return this.settings && this.settings.Title ? this.settings.Title : "";
  }

  get phone() {
    return this.settings && this.settings.Phone ? this.settings.Phone : "";
  }

  get address() {
    return this.settings && this.settings.Address ? this.settings.Address : "";
  }

  get tenantSubtitle() {
    return this.settings && this.settings.Description
      ? this.settings.Description
      : "";
  }

  get contactEmail() {
    return this.settings && this.settings.Email ? this.settings.Email : "";
  }

  get facebook() {
    return this.settings && this.settings.Facebook
      ? this.settings.Facebook
      : "";
  }

  get instagram() {
    return this.settings && this.settings.Instagram
      ? this.settings.Instagram
      : "";
  }

  get twitter() {
    return this.settings && this.settings.Twitter ? this.settings.Twitter : "";
  }

  get footerCopyright() {
    const title = this.tenantTitle ? this.tenantTitle.trim() : "";
    const brand = title ? title : "Mahe";
    return `${brand} copyright ${this.currentYear}. All rights reserved`;
  }

  async requestMoreInfo() {
    if (Format.IsNull(this.requestEmail)) {
      return;
    }
    Global.TriggerDomId = "requestInfoBtn";
    const url = Settings.HostName + "/api/publiccomms/info-request";
    const questionRequest = {
      email: this.requestEmail,
      question: this.$t("Request More Info").toString(),
    };

    const data = await new CrudService().httpPost(url, questionRequest);
    if (data == null || data.ok !== true) {
      return;
    }

    this.hideRequestInfoFrom = true;
    this.requestInfoMessage = this.$t(
      "Thanks! We'll contact you soon.",
    ).toString();
  }

  get brandLogoSrc() {
    if (
      this.settings &&
      this.settings.Uploads &&
      this.settings.Mainlogo &&
      this.settings.Uploads.length > 0 &&
      this.settings.Mainlogo.length > 0
    ) {
      return this.settings.Uploads + "/" + this.settings.Mainlogo;
    }
    return this.logoMarkSrc;
  }

  logoMarkSrc = require("@/assets/footerV2/logo-mark.svg");
  phoneIconSrc = require("@/assets/footerV2/icon-phone.svg");
  emailIconSrc = require("@/assets/footerV2/icon-email.svg");
  mapPin1Src = require("@/assets/footerV2/icon-map-pin-1.svg");
  mapPin2Src = require("@/assets/footerV2/icon-map-pin-2.svg");
}
